import iconOne from '../../assets/service/1.png';
import iconTwo from '../../assets/service/2.png';
import iconThree from '../../assets/service/3.png';
import iconFour from '../../assets/service/4.png';

import serviceBanner from '../../assets/servicePage/1.png';

import symptomsIconOne from '../../assets/symptoms/1.png';
import symptomsIconTwo from '../../assets/symptoms/2.png';
import symptomsIconThree from '../../assets/symptoms/3.png';
import symptomsIconFour from '../../assets/symptoms/4.png';
import symptomsIconFive from '../../assets/symptoms/5.png';

const ServicesData = [
    {
        'icon': iconFour,
        'img': serviceBanner,
        'bannerText': 'Root canals have gotten a bad reputation, but we dentists don’t know why! These are the types of treatments that actually make you feel better!',
        'url': 'root-canal-treatment',
        'title': 'Root Canal Treatment',
        'description': 'Save your natural tooth and relieve pain with our expert root canal treatments.',
        'symptomsHeader': 'Sign and symptoms you need root canal',
        'symptoms': [
            {
                'icon' : symptomsIconOne,
                'title' : 'Spontaneous pain',
                'description':'Spontaneous pain even when youre not eating or drinking' 
            },
            {
                'icon' : symptomsIconTwo,
                'title' : 'Discoloration of tooth',
                'description':'Darkening or discoloration of a tooth' 
            },
            {
                'icon' : symptomsIconThree,
                'title' : 'Middle night pain',
                'description':'Pain that wakes you up in the middle of the night' 
            },
            {
                'icon' : symptomsIconFour,
                'title' : 'Tenderness in gums',
                'description':'From floss bosses to sweet tooths, every mouth is welcome.' 
            },
            {
                'icon' : symptomsIconFive,
                'title' : 'Extreme sensitivity',
                'description':'Extreme sensitivity to cold or heat when your’e drink or eat' 
            }
        ]
    },
    {
        'icon': iconTwo,
        'img': serviceBanner,
        'bannerText': 'Dental implants are the gold standard for replacing missing teeth, providing both functionality and aesthetics that feel like natural teeth.',
        'url': 'implants',
        'title': 'Implants',
        'description': 'Achieve a natural look and lasting solution for missing teeth with state-of-the-art dental implants.',
        'symptomsHeader': 'Signs you may need dental implants',
        'symptoms': [
            {
                'icon' : symptomsIconOne,
                'title' : 'Missing teeth',
                'description':'Gaps in your smile due to missing teeth' 
            },
            {
                'icon' : symptomsIconTwo,
                'title' : 'Difficulty chewing',
                'description':'Trouble chewing certain foods due to tooth loss' 
            },
            {
                'icon' : symptomsIconThree,
                'title' : 'Bone loss in the jaw',
                'description':'Deterioration of jawbone where teeth are missing' 
            },
            {
                'icon' : symptomsIconFour,
                'title' : 'Loose dentures',
                'description':'Dentures that slip or shift uncomfortably' 
            },
            {
                'icon' : symptomsIconFive,
                'title' : 'Wanting a permanent solution',
                'description':'Seeking a durable and natural-looking alternative to bridges or dentures' 
            }
        ]
    },
    {
        'icon': iconFour,
        'img': serviceBanner,
        'bannerText': 'Crowns and bridges are restorative treatments designed to strengthen damaged teeth and replace missing ones, enhancing both function and appearance.',
        'url': 'crown-bridges',
        'title': 'Crown & Bridges',
        'description': 'Rebuild your smile with high-quality crowns and bridges designed for durability and aesthetics.',
        'symptomsHeader': 'Signs you may need dental crowns or bridges',
        'symptoms': [
            {
                'icon' : symptomsIconOne,
                'title' : 'Cracked or Damaged Teeth',
                'description':'Teeth that are fractured or worn down' 
            },
            {
                'icon' : symptomsIconTwo,
                'title' : 'Large fillings',
                'description':'Teeth with large fillings needing extra support' 
            },
            {
                'icon' : symptomsIconThree,
                'title' : 'Missing teeth',
                'description':'Gaps in your smile requiring a fixed solution' 
            },
            {
                'icon' : symptomsIconFour,
                'title' : 'Weak teeth',
                'description':'Teeth at the risk of breaking' 
            }
        ]
    },
    {
        'icon': iconThree,
        'img': serviceBanner,
        'bannerText': 'Teeth whitening is a cosmetic procedure that brightens your smile by removing stains and discoloration.',
        'url': 'whitening',
        'title': 'Whitening',
        'description': 'Brighten your smile with professional whitening treatments that deliver stunning results.',
        'symptomsHeader': 'Signs you may benefit from teeth whitening',
        'symptoms': [
            {
                'icon' : symptomsIconOne,
                'title' : 'Stained teeth',
                'description':'Teeth darkended by coffee, tea, or tobacco' 
            },
            {
                'icon' : symptomsIconTwo,
                'title' : 'Yellow teeth',
                'description':'Age related discoloration or yellowing' 
            },
            {
                'icon' : symptomsIconThree,
                'title' : 'Special Occasions',
                'description':'Wanting to look your best for a special event like wedding' 
            },
            {
                'icon' : symptomsIconFour,
                'title' : 'Uneven Coloration',
                'description':'Spots or inconsistent coloration on teeth' 
            },
            {
                'icon' : symptomsIconFive,
                'title' : 'Desire for a brighter smile',
                'description':'Wanting to boost your confidence with whiter teeth' 
            }
        ]
    },
    {
        'icon': iconFour,
        'img': serviceBanner,
        'bannerText': 'Orthodontic treatments like braces and Invisalign straighten teeth, correct bite issues, and improve overall oral health.',
        'url': 'braces-invisalign',
        'title': 'Braces & Invisalign',
        'description': 'Align your teeth effortlessly with traditional braces or nearly invisible Invisalign aligners.',
        'symptomsHeader': 'Signs you may need orthodontic treatment',
        'symptoms': [
            {
                'icon' : symptomsIconOne,
                'title' : 'Crooked teeth',
                'description':'Misaligned or overcrowded teeth' 
            },
            {
                'icon' : symptomsIconTwo,
                'title' : 'Gaps between teeth',
                'description':'Noticeable spaces between teeth' 
            },
            {
                'icon' : symptomsIconThree,
                'title' : 'Overbite or underbite',
                'description':'Teeth that don’t align properly when biting' 
            },
            {
                'icon' : symptomsIconFour,
                'title' : 'Jaw pain',
                'description':'Discomfort due to bite issues' 
            },
            {
                'icon' : symptomsIconFive,
                'title' : 'Desire for a straight smile',
                'description':'Wanting a more confident, aligned smile' 
            }
        ]
    },
    {
        'icon': iconFour,
        'img': serviceBanner,
        'bannerText': 'Smile design combines various cosmetic dental procedures to create a customized, flawless smile.',
        'url': 'smile-design',
        'title': 'Smile Design',
        'description': 'Redefine your smile with tailored cosmetic dental treatments that enhance your confidence.  ',
        'symptomsHeader': 'Signs you may need smile design',
        'symptoms': [
            {
                'icon' : symptomsIconOne,
                'title' : 'Chipped or broken teeth',
                'description':'Visible imperfections affecting your smile' 
            },
            {
                'icon' : symptomsIconTwo,
                'title' : 'Gummy smile',
                'description':'Excess gum tissue showing when you smile' 
            },
            {
                'icon' : symptomsIconThree,
                'title' : 'Discolored teeth',
                'description':'Persistent stains or discoloration' 
            },
            {
                'icon' : symptomsIconFour,
                'title' : 'Uneven teeth',
                'description':'Teeth of varying shapes or sizes' 
            },
            {
                'icon' : symptomsIconFive,
                'title' : 'Desire for a perfect smile',
                'description':'Seeking a comprehensive cosmetic transformation' 
            }
        ]
    },
    {
        'icon': iconOne,
        'img': serviceBanner,
        'bannerText': 'Dentures are custom-made to replace multiple missing teeth, restoring your smile and making it easier to eat and speak.',
        'url': 'dentures',
        'title': 'Dentures',
        'description': 'Restore your smile and confidence with custom-fit dentures designed for comfort and functionality.',
        'symptomsHeader': 'Signs you may need dentures',
        'symptoms': [
            {
                'icon' : symptomsIconOne,
                'title' : 'Multiple missing teeth',
                'description':'Significant tooth loss in one or both arches' 
            },
            {
                'icon' : symptomsIconTwo,
                'title' : 'Difficulty chewing',
                'description':'Trouble eating due to lack of teeth' 
            },
            {
                'icon' : symptomsIconThree,
                'title' : 'Shifting teeth',
                'description':'Remaining teeth shifting into gaps' 
            },
            {
                'icon' : symptomsIconFour,
                'title' : 'Gum Pain',
                'description':'Irritation from missing or poorly aligned teeth' 
            }
        ]
    },
    {
        'icon': iconFour,
        'img': serviceBanner,
        'bannerText': 'Kids dentistry focuses on preventive and therapeutic dental care for children, ensuring healthy smiles from an early age.',
        'url': 'kids-dentistry',
        'title': 'Kids Dentistry',
        'description': 'Ensure your child’s oral health with gentle and specialized pediatric dental care.',
        'symptomsHeader': 'Signs your child may need dental care',
        'symptoms': [
            {
                'icon' : symptomsIconOne,
                'title' : 'Tooth pain',
                'description':'Complaints of toothache or sensivity' 
            },
            {
                'icon' : symptomsIconTwo,
                'title' : 'Cavities',
                'description':'Visible signs of decay or holes in teeth' 
            },
            {
                'icon' : symptomsIconThree,
                'title' : 'Early orthodontic issues',
                'description':'Crowding, gaps, or alignment concerns' 
            },
            {
                'icon' : symptomsIconFour,
                'title' : 'Teething problems',
                'description':'Pain or discomfort as new teeth emerges' 
            },
            {
                'icon' : symptomsIconFive,
                'title' : 'Regular checkups',
                'description':'Ensuring proper oral hygiene and development' 
            }
        ]
    }    
]

export default ServicesData;